import ReactLoading from "react-loading";

export const FormLoading = (
    {
        show,
        content
    }: {
        show: boolean,
        content?: string
    }
) => {
    if (!show) return null;
    return (
        <div
            style={{
                position: 'absolute',
                top:0,
                right:0,
                bottom:0,
                left:0
            }}
        >
            <div
                style={{
                    position: 'absolute',
                    textAlign: 'center',
                    top:'50%',
                    left:'50%',
                    transform:'translate(-50%, -50%)',
                    background:'rgba(0, 0, 0, .7)',
                    borderRadius:12,
                    padding:'32px 32px',
                    maxWidth:400,
                    boxShadow:'0 4px 12px rgba(0, 0, 0, .2)'
                }}
            >
                <ReactLoading type="bubbles" color="#bbb" width={36} height={36} />
                {
                    content &&
                    <div
                        style={{
                            color:'#fff',
                            cursor:'default'
                        }}
                    >{content}</div>
                }
            </div>
        </div>
    )
}